module.exports = __webpack_public_path__ + "img/icon_yhq.db54f986.png";